import dictionaryService, {NamedLabelArgument} from '@/core/translation/dictionary.service';
function get(key: string, args: (string | number | undefined)[] = []): string {
    return dictionaryService.get(key, args);
}
function exists(key: string): boolean {
    return dictionaryService.exists(key);
}
function translate(key: string): string {
    return dictionaryService.translate(key);
}
function countryNameByCountryCode(countryCode: string): string {
    return dictionaryService.countryNameByCountryCode(countryCode);
}
function languageNameByLanguageCode(languageCode: string): string {
    return dictionaryService.languageNameByLanguageCode(languageCode);
}
function getAsMarkup(key: string, args: string[] = []): string {
    return dictionaryService.getAsMarkup(key, args);
}
function formatAsMarkup(text: string = ''): string {
    return dictionaryService.formatAsMarkup(text);
}
function localeNumber(number: number | string): string {
    return dictionaryService.localeNumber(number).toString();
}
function getWithNamedValues(key: string, namedArguments: NamedLabelArgument = {}, failWithMissingRecords: boolean = false, useKeyAsLabel: boolean = false): string | null {
    return dictionaryService.getWithNamedValues(key, namedArguments, failWithMissingRecords, useKeyAsLabel);
}
function getWithNamedValuesUntilString(keys: string[], namedArguments: NamedLabelArgument = {}): string | null {
    return dictionaryService.getWithNamedValuesUntilString(keys, namedArguments);
}

export default {
    install(Vue) {
        Vue.prototype.$dictionary = {
            get,
            exists,
            getAsMarkup,
            countryNameByCountryCode,
            languageNameByLanguageCode,
            translate,
            formatAsMarkup,
            localeNumber,
            getWithNamedValues,
            getWithNamedValuesUntilString
        };
    }
};
